// export const API_URL = "http://10.2.3.22:8000/api/v1";
// export const API_URL = "https://uatscanapi.totalbiometrics.net/api/v1";
export const API_URL = "https://scanapi.totalbiometrics.net/api/v1";
export default API_URL;

